import { icon, Icon } from '../lib/fa-icons.js';
import Widget from "./base.js";
import { postSubscribeUnlock } from 'tpm-lib/post-unlock.js';

// Normalize slugs for comparison: the legacy Brevo lists use underscores
// (the_backchannel) while editorial-newsletter rows use hyphens
// (the-backchannel). Match either convention so the widget works pre- and
// post-beehiiv-switchover.
const slugMatch = (a, b) => (a ?? "").replace(/[-_]/g, "-") === (b ?? "").replace(/[-_]/g, "-");


export class NewsletterInTOCBig extends Widget {
	componentWillMount() {
		this.handleEmail = this.handleEmail.bind(this);
		this.handleCheckbox = this.handleCheckbox.bind(this);
		this.getData();
		this.state.hidden = true;
		
	}

	componentDidMount() {
		const urlParams = new URLSearchParams(window.location.search);
		const addToMultipleLists = urlParams.get("addToMultipleLists");
		if (addToMultipleLists) {
			this.postData({
				addToMultipleLists,
				nextPath: encodeURIComponent(window.location.pathname),
			});
		}
	}

	clearErrors() {
		this.setState({ errors: null });
	}

	getData() {
		this.request("GET");
	}

	postData(opts) {
		this.clearErrors();
		this.request("POST", opts);
	}

	request(method, data = {}) {
		const self = this;

		let params = `?`;
		Object.keys(data).forEach((k) => {
			params += `${k}=${data[k]}&`;
		});

		fetch(
			`https://accounts.${document.location.hostname}/doesspress/email-list${params}`,
			{
				method: `${method}`,
				credentials: "include",
			}
		)
			.then((r) => {
				return r.json();
			})
			.then((r) => {
				if (method === "GET") {
					// console.log(r.bindings);
					self.setState(
						{
							emailLists: r.bindings.emailLists,
							ident: r.bindings.ident,
						},
						() => {
							// console.log(self.state);
						}
					);
				} else {
					if (r.errors) {
						self.setState({ error: r.errors[0] });
					}
					if (r.confirmation) {
						// Post-subscribe unlock: shared transition (in-place content
						// swap when a token was minted; reload fallback otherwise).
						postSubscribeUnlock(r.confirmation, data);
						self.setState({ confirmation: r.confirmation });

						/*
							Optimistically flip the just-subscribed list (the handleCheckbox
							POST) so the collapsed "Subscribed [check]" button renders
							immediately — the same UI a reload produces — instead of blanking
							the widget while hidden is still true. The next GET (page load)
							reconciles with the server. listId arrives as a string from the
							hidden input while list ids are numeric (Brevo legacy) or strings
							(beehiiv), so compare loosely.
						*/
						if (data.addToList) {
							self.setState({
								emailLists: (self.state.emailLists || []).map((list) =>
									String(list.id) === String(data.listId)
										? { ...list, subscribed: true }
										: list
								),
							});
						}
					}
				}
			});
	}

	handleCheckbox(e) {
		const signedIn = this.state.ident.id;
		if (!signedIn) return;

		const opts = {
			listId: document.querySelector(
				'.js_newsletter-listId'
			).value,
		};
		//always set opts.addToList = true, this form never unsubs anyone
		opts.addToList = true;

		this.postData(opts);
	}

	handleEmail(e) {
		e.preventDefault();
		debugger;

		const checkedInputs = document.querySelectorAll(
			".js_newsletter-checkbox:checked"
		);
		if (checkedInputs.length === 0) {
			this.setState({
				error: { message: "Please select a newsletter to subscribe to" },
			});
			return;
		} else {
			this.setState({
				error: null,
			});
		}

		const listIds = Array.from(checkedInputs).map(
			(input) =>
				document.querySelector(
					'.NewsletterInTOCBig__Form input[name="listId"]'
				).value
		);

		const opts = {
			addToMultipleLists: listIds.join(","),
			email: document.querySelector("#newEmail").value,
			nextPath: encodeURIComponent(window.location.pathname),
		};


		this.postData(opts);
	}

	listDescription(list) {
		if (slugMatch(list.slug, "the_weekender")) {
			return (
				<div>
					<p className="medium">Subscribe to The Weekender Newsletter</p>
					<p>Unpack the funny, surreal, and strange in U.S. politics and culture with Allegra Kirkland, Derick Dirmaier and the TPM team.</p>
				</div>
			);
		}

		if (slugMatch(list.slug, "the_franchise")) {
			return (
				<div>
					<p className="medium">Subscribe to The Franchise Newsletter</p>
					<p>What you need to know about the assault on voting rights and democracy in America, brought to you
					weekly by TPM reporter Khaya Himmelman.</p>
				</div>
			);
		}

		if (slugMatch(list.slug, "the_brief")) {
			return (
				<div>
					<p className="medium">Get The Brief free in your inbox</p>
					<p>John Light starts your day with some quick thoughts on key stories TPM will be following.</p>
				</div>
			);
		}

		if (slugMatch(list.slug, "morning_memo")) {
			return (
				<div>
					<p className="medium">Subscribe to The Morning Memo </p>
					<p>David Kurtz brings you the essential political roundup each weekday morning.</p>
				</div>
			);
		}

		if (slugMatch(list.slug, "the_backchannel")) {
			if (this.props.membership && this.props.membership === "1")
				return (
					<div>
						<p className="medium">Subscribe to The Backchannel Newsletter</p>

						<p>Josh Marshall's direct
						line for insight, analysis, and conversation. TPM members receive
						one must-read daily.</p>
					</div>
				);

			return (
				<div>
					<p className="medium">Subscribe to The Backchannel Newsletter</p>
					<p>Josh Marshall's direct line for insight, analysis, and conversation. Non-members can subscribe to
					the free edition and receive one must-read from Josh weekly.</p>
				</div>
			);
		}

		return "";
	}

	renderNotYetSubscribed(list) {
		if (list.subscribed) return this.renderButton(true);
 
		if (this.state.confirmation && this.state.hidden) return;

		if (this.state.confirmation) {
			return (
				<div className={`NewsletterInTOCBig__Inner`}>
					<div className={`NewsletterInTOCBig__Column --center`}>
						<div className="NewsletterInTOCBig__Hide" onClick={() => this.setState({ hidden: true })}>
							<Icon name="xmark" style="light" />
						</div>
						<p className="big">You’re Subscribed!</p>
						<p>Manage your subscription in the{' '}
							<a
								href="https://accounts.talkingpointsmemo.com/account#email"
								target="_blank"
								className="NewsletterInTOCBig__Link"
							>
								account&nbsp;panel&nbsp;<Icon name="arrow-right-long" style="light" />
							</a>
						</p>
					</div>
				</div>
			);
		}

		return (
			<div>
				<input className="js_newsletter-listId" type="hidden" name="listId" value={list.id} />
				<span
					className="NewsletterInTOCBig__Show"
					onClick={()=>{this.handleCheckbox()}}
				>
					Subscribe <Icon name="plus" style="light" />
				</span>
			</div>
		);
	}


	renderAlreadySubscribed() {
		if (this.state.hidden) return this.renderButton(true);
		return (
			<div className={`NewsletterInTOCBig__Inner`}>
				<div className={`NewsletterInTOCBig__Column --center`}>
					<div className="NewsletterInTOCBig__Hide" onClick={() => this.setState({ hidden: true })}>
						<Icon name="xmark" style="light" />
					</div>
					<p className="big">You’re Subscribed!</p>
					<p>Manage your subscription in the{' '}
						<a
							href="https://accounts.talkingpointsmemo.com/account#email"
							target="_blank"
							className="NewsletterInTOCBig__Link"
						>
							account&nbsp;panel&nbsp;<Icon name="arrow-right-long" style="light" />
						</a>
					</p>
				</div>
			</div>
		);
	}	

	renderEmailForm(list) {
		if (this.state.hidden) return this.renderButton(list.subscribed);
		const confirmAcctCreation = this.state.confirmation;
		return (
			<div className={`NewsletterInTOCBig__Inner`}>
				<div className={`NewsletterInTOCBig__Column`}>
					<div className="NewsletterInTOCBig__Hide" onClick={() => this.setState({ hidden: true })}>
						<Icon name="xmark" style="light" />
					</div>
			
					{!confirmAcctCreation && this.renderEmailFormInner(list)}

					{confirmAcctCreation && (
						<div className="NewsletterInTOCBig__Confirmation">
							<h4>Check your inbox!</h4>
							<p>{this.state.confirmation.message}</p>
							<p>
								Don’t see an email? Please check your spam folder or{" "}
								<a href="https://talkingpointsmemo.com/contact">
									contact&nbsp;us
								</a>{" "}
								for assistance.
							</p>
						</div>
					)}


					{this.state.error && (
						<p
							style={{
								background: "#ffefb0",
								padding: "10px",
							}}
						>
							{this.state.error.message}
						</p>
					)}
				</div>
			</div>
		);
	}

	renderEmailFormInner(list) {
		return (
			<div className="NewsletterInTOCBig__Form">
				<input type="hidden" name="listId" value={list.id} />
				<input
					className=" js_newsletter-checkbox"
					id={`id_${list.id}`}
					name="addToList"
					type="checkbox"
					defaultChecked={true}
					style={{ display: "none" }}
				/>
				<div className="NewsletterInTOCBig__Description">
					{this.listDescription(list)}
				</div>
				<div className="NewsletterInTOCBig__Flex">
					<label
						htmlFor={`id_${list.id}`}
						style={{
							position: "absolute",
							width: "1px",
							height: "1px",
							padding: 0,
							margin: "-1px",
							overflow: "hidden",
							clip: "rect(0,0,0,0)",
							border: 0,
						}}
					>
						Email Address
					</label>
					<input
						type="email"
						id="newEmail"
						pattern=".+@example\.com"
						required
						placeholder="Email Address"
					/>
					<div
						className="NewsletterInTOCBig__Button --min-w Button --transparent-to-red"
						onClick={this.handleEmail}
					>
						Subscribe
					</div>
				</div>
			</div>
		);
	}

	categoryToList(category) {
		const lists = this.state.emailLists;

		if (category === "the-weekender") {
			return lists.find((list) => slugMatch(list.slug, "the_weekender"));
		}

		if (category === "the-franchise") {
			return lists.find((list) => slugMatch(list.slug, "the_franchise"));
		}

		if (category === "the-brief") {
			return lists.find((list) => slugMatch(list.slug, "the_brief"));
		}

		if (category === "the-backchannel") {
			return lists.find((list) => slugMatch(list.slug, "the_backchannel"));
		}

		if (category === "where-things-stand") {
			return lists.find((list) => slugMatch(list.slug, "where_things_stand"));
		}

		if (category === "morning-memo") {
			return lists.find((list) => slugMatch(list.slug, "morning_memo"));
		}

		debugger
		return null;
	}

	renderButton(alreadySubscribed = false) {
		return (
			<div className="NewsletterInTOCBig__Show" onClick={() => this.setState({ hidden: false })}>
				{alreadySubscribed &&(<span>Subscribed <Icon name="check" style="regular" /></span>)}
				{!alreadySubscribed &&(<span>Subscribe <Icon name="plus" style="light" /></span>)}
			</div>
		)
	}

	/* 
	1. if signed in and subscribed, show manage subscription btn + panel (renderAlreadySubscribed)
	2. if singned in but not subscribed, show sub btn
	3. if not signed in, show email form
	 */

	renderContent() {

		if (
			!["the-weekender", "the-franchise", "the-backchannel", "the-brief", "where-things-stand", "morning-memo"].includes(
				this.props.category
			)
		) {
			return;
		}


		if (this.state.error && !this.state.emailLists) return;
		if (!this.state.emailLists) return;

		/* 2 - signed in and already sub'd */
		const signedIn = this.state.ident.id;
		const theList = this.categoryToList(this.props.category);
		const alreadySubscribed = signedIn && theList && theList.subscribed;
		if (alreadySubscribed) return this.renderAlreadySubscribed();
		

		/* 3 - signed in but not sub'd */
		if (signedIn) return this.renderNotYetSubscribed(theList); 
		
		/* 4 - not signed in, email form */
		if (!signedIn) return this.renderEmailForm(theList); 
		
	}
}
